import { DialogActions } from '@mui/material';
import { APPROVAL_TYPES, COMITEE_TYPES } from 'lib/api/approvals/types';
import CustomButton from 'lib/designSystem/Button';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import Committee from 'pages/Finance/Components/Financing/common/Comittee';
import { ComiteeTabProvider } from 'pages/Finance/Components/Financing/common/Comittee/ComiteeTabProvider';
import React from 'react';

import Evaluations from './components/Evaluations';

const FactoringRiskTab = (props: any) => {
  const { setOpenShoppingCart, selectedRequest, setUp } = props;
  const startValue = 0;

  const ImportedModuleLayout = (props: any) => {
    return (
      <div>
        {props.children}
        <DialogActions>
          <CustomButton
            onClick={() => setOpenShoppingCart(false)}
            color="secondary"
            style={{ marginTop: '10px' }}
          >
            {' '}
            Salir{' '}
          </CustomButton>
        </DialogActions>
      </div>
    );
  };

  const comiteeTabInfo = {
    requestType: APPROVAL_TYPES.FACTORING_QUOTE,
    comiteeType: COMITEE_TYPES.RISK,
    requestId: selectedRequest.quoteActive.id,
    comiteeId: selectedRequest.quoteActive.comitee?.id,
    canEdit: selectedRequest.status === 'En revisión',
    isRejected: selectedRequest.status === 'Rechazada',
    isActive: ['Completada', 'Activa', 'En giro', 'Aceptada'].includes(
      selectedRequest.status,
    ),
    refreshRequest: () => setUp(selectedRequest.id),
  };

  const tabs = [
    {
      index: 1,
      label: 'Comité',
      component: (
        <ImportedModuleLayout>
          <ComiteeTabProvider info={comiteeTabInfo}>
            <Committee />
          </ComiteeTabProvider>
        </ImportedModuleLayout>
      ),
    },
    {
      index: 3,
      label: 'Evaluaciones',
      component: (
        <ImportedModuleLayout>
          <Evaluations
            selectedRequest={selectedRequest}
            setOpenShoppingCart={setOpenShoppingCart}
          />
        </ImportedModuleLayout>
      ),
    },
  ];

  return <EnhancedTab startValue={startValue} tabs={tabs} />;
};

export default FactoringRiskTab;
